import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { patientPropType } from 'Shared/types';

import { SUMMARY_NOTE_FIELD_NAME } from 'App/components/Assessments/constants';
import { MED_ASSOCIATION_FIELD_NAME } from 'App/components/Assessments/question/MedicationAssociation/constants';
import ScrollToElementLink from '../ScrollToElementLink';
import AssessmentQuestionText from './AssessmentQuestionText';

const AssessmentQuestionErrorDisplay = ({ questionId, patient }) => {
    const { values } = useFormikContext();

    function getQuestionText() {
        if (questionId === MED_ASSOCIATION_FIELD_NAME) {
            return 'Medication Association';
        }

        if (questionId === SUMMARY_NOTE_FIELD_NAME) {
            return 'Summary Note';
        }

        const question = Object.values(values).find((q) => q.questionId === questionId);
        if (!question) {
            return null;
        }
        return <AssessmentQuestionText question={question} viewMode={values.viewMode} patient={patient} />;
    }

    const questionText = getQuestionText();
    if (!questionText) {
        return null;
    }

    return (
        <li id={`required-error-${questionId}`}>
            <ScrollToElementLink elementId={questionId}>{questionText}</ScrollToElementLink>
        </li>
    );
};

AssessmentQuestionErrorDisplay.propTypes = {
    questionId: PropTypes.string.isRequired,
    patient: patientPropType.isRequired,
};

export default AssessmentQuestionErrorDisplay;
